module.exports = __webpack_public_path__ + "f82a51941674aa3c30638d6dd1e08bf6.pdf";